import BackHeaderV2 from './BackHeaderV2';

export default BackHeaderV2;
export * from './BackHeaderV2';
